import type { ServiceLine } from '../services/api';

/** The subset of the order response this helper needs — satisfied by both `OrderListItem` and `OrderDetail`. */
export interface ServiceLineSource {
  serviceName?: string | null;
  serviceLines?: ServiceLine[] | null;
}

/**
 * #1193 — the customer's selection: the order's lines minus the ones that only repeat the service.
 * A flat service's single line is labelled with the service name, and a line without a label says
 * nothing, so both drop out; an empty result means there is no selection to show.
 */
export function selectedOptions(order: ServiceLineSource): ServiceLine[] {
  const labelled = (order.serviceLines ?? []).filter((l) => l.label?.trim());
  const name = order.serviceName?.trim();
  if (labelled.length === 1 && labelled[0].label!.trim() === name) return [];
  return labelled;
}
